import {
    ResponsiveContainer,
    XAxis,
    YAxis,
    CartesianGrid,
    Line,
    Area,
    ComposedChart,
    Tooltip as RechartTooltip
} from "recharts"
import imges from "../../../Utils/assets/img/chart/card-1.png"
import { useEffect, useState } from "react"
import { GetRequest } from "../../../Utils/hooks/ApiHandler"

export const CompanyHeaderCards = ({ showCards, customerId, loginUserId, headers, extras }) => {

    const [cardData, setCardData] = useState(null)

    // top card content data
    const getCardContent = async () => {
        try {
            const res = await GetRequest(
                `company/companyCard/${customerId}/${loginUserId}`,
                { headers },
                extras
            )
            if (res.status === 'fail' || res.success === false) {
                // toast.error("failed to get card details")
                return
            }
            setCardData(res.data)
        } catch (error) {
            // toast.error("Something went wrong")
            return
        }
    }

    useEffect(() => {
        getCardContent()
    }, [])
    const top10CitiesData = cardData?.cities
        ?.filter(c => c.city_name)       // remove null cities
        ?.slice(0, 10)                   // top 10
        ?.map(c => ({
            city: c.city_name.length > 6
                ? c.city_name.slice(0, 6) + "…"
                : c.city_name,
            companies: c.company,
        }));

    return (
        <>
            {!showCards && cardData && (
                <div className="row  mb-0 mt-3 w-100 ms-0">
                    <div
                        className="col-xxl-3 col-lg-3 col-md-6 ps-0 newCardsHeading"
                        style={{ height: "88%", zIndex: 0 }}
                    >
                        <div className="card custom-card overflow-hidden" style={{ height: "160px" }}>
                            <div className="card-body pt-2 w-100 pb-2 ps-2">
                                <div className="d-flex align-items-top justify-content-between">
                                    <div>
                                        <span
                                            className="avatar avatar-md avatar-rounded"
                                            style={{ background: "#3d9fd7" }}
                                        >
                                            <i className="ti ti-briefcase fs-16"></i>
                                        </span>
                                    </div>
                                    <div className="flex-fill ms-3">
                                        <div className="flex-wrap">
                                            <div>
                                                <a
                                                    className="text-warning"
                                                >
                                                    <p
                                                        className=" mb-0"
                                                        style={{ fontWeight: 200, color: "#3d9fd7" }}
                                                    >
                                                        Companies created by me
                                                    </p>
                                                    <h4
                                                        className="fw-semibold mt-1 d-flex fs-20 justify-content-between "
                                                        style={{ color: "black" }}
                                                    >
                                                        {cardData?.created_by_me ?? 0}
                                                        {/* 12,34,449{" "} */}
                                                        <div
                                                            id="crm-total-deals"
                                                            style={{
                                                                width: 80,
                                                                height: "auto",
                                                                minHeight: "35px",
                                                            }}
                                                        >
                                                            <div
                                                                id="apexchartsn21xcu4d"
                                                                className="apexcharts-canvas apexchartsn21xcu4d apexcharts-theme-light d-flex justify-content-end align-items-centre"
                                                                style={{ width: 100, height: 26 }}
                                                            >
                                                                <img src={imges} style={{ width: 67 }} />
                                                            </div>
                                                        </div>
                                                    </h4>
                                                </a>
                                            </div>
                                        </div>
                                        {/*  */}
                                        <div
                                            className="d-flex align-items-center justify-content-between mt-1"
                                            style={{ lineHeight: 1.2 }}
                                        >
                                            <div>
                                                <p className="mb-0 text-success fw-semibold">
                                                    {/* 1356  */}
                                                    {cardData?.currentMonth_byMe ?? 0}
                                                </p>
                                                <span className="text-muted op-7 fs-11">
                                                    Total Collection
                                                </span>
                                            </div>
                                            <div className="text-end">
                                                <p className="mb-0 text-success fw-semibold">
                                                    {/* 784  */}
                                                    {cardData?.lastMonth_byMe ?? 0}
                                                </p>
                                                <span className="text-muted op-7 fs-11">
                                                    Last Month
                                                </span>
                                            </div>
                                        </div>
                                        {/*  */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        className="col-xxl-3 col-lg-3 col-md-6 ps-0 newCardsHeading"
                        style={{ height: "88%", zIndex: 0 }}
                    >
                        <div className="card custom-card overflow-hidden" style={{ height: "160px" }}>
                            <div className="card-body pt-2 w-100 pb-2 ps-2">
                                <div className="d-flex align-items-top justify-content-between">
                                    <div>
                                        <span className="avatar avatar-md avatar-rounded bg-secondary">
                                            <i className="ti ti-wallet fs-16"></i>
                                        </span>
                                    </div>
                                    <div className="flex-fill ms-3">
                                        <div className="flex-wrap">
                                            <div>
                                                <a
                                                    className="text-warning"
                                                    href="##"
                                                >
                                                    <p
                                                        className="text-secondary mb-0"
                                                        style={{ fontWeight: 200 }}
                                                    >
                                                        All Companies
                                                    </p>
                                                    <h4
                                                        className="fw-semibold mt-1 d-flex fs-20 justify-content-between "
                                                        style={{ color: "black" }}
                                                    >
                                                        {/* 12,34,449{" "} */}
                                                        {cardData?.all_company ?? 0}
                                                        <div
                                                            id="crm-total-deals"
                                                            style={{
                                                                width: 80,
                                                                height: "auto",
                                                                minHeight: "35px",
                                                            }}
                                                        >
                                                            <div
                                                                id="apexchartsn21xcu4d"
                                                                className="apexcharts-canvas apexchartsn21xcu4d apexcharts-theme-light d-flex justify-content-end align-items-centre"
                                                                style={{ width: 100, height: 26 }}
                                                            >
                                                                <img src={imges} style={{ width: 67 }} />
                                                            </div>
                                                        </div>
                                                    </h4>
                                                </a>
                                            </div>
                                        </div>
                                        <div
                                            className="d-flex align-items-center justify-content-between mt-1"
                                            style={{ lineHeight: 1.2 }}
                                        >
                                            <div>
                                                <p className="mb-0 text-success fw-semibold">
                                                    {cardData?.currentMonth ?? 0}
                                                </p>
                                                <span className="text-muted op-7 fs-11">
                                                    Total Collection
                                                </span>
                                            </div>
                                            <div className="text-end">
                                                <p className="mb-0 text-success fw-semibold">
                                                    {/* 784 */}
                                                    {cardData?.lastMonth ?? 0}
                                                </p>
                                                <span className="text-muted op-7 fs-11">
                                                    Last Month
                                                </span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="col-xxl-6 col-lg-6 col-md-6 ps-0 pb-0 newCardsHeading">
                        <div className="card custom-card overflow-hidden p-0" style={{ height: "160px" }}>
                            <div className="card-body w-100" style={{ height: "88%", zIndex: 0 }}>

                                {/* HEADER (ROW) */}
                                <div className="d-flex align-items-center">
                                    <span
                                        className="avatar avatar-md avatar-rounded"
                                        style={{ background: "#3faa5f" }}
                                    >
                                        <i className="ti ti-briefcase fs-16"></i>
                                    </span>

                                    <p
                                        className="mb-0 ms-3"
                                        style={{ fontWeight: 200, color: "#3faa5f" }}
                                    >
                                        Companies from top 10 cities
                                    </p>
                                </div>

                                <div style={{ width: "100%", height: 95 }}>
                                    {top10CitiesData?.length ? (
                                        <ResponsiveContainer width="100%" height="110%">
                                            <ComposedChart
                                                data={top10CitiesData}
                                                margin={{ top: 10, right: 20, left: 0, bottom: 30 }}
                                            >
                                                <defs>
                                                    <linearGradient id="cityGradient" x1="0" y1="0" x2="0" y2="1">
                                                        <stop offset="5%" stopColor="#865adf" stopOpacity={0.8} />
                                                        <stop offset="95%" stopColor="#865adf" stopOpacity={0.1} />
                                                    </linearGradient>
                                                </defs>

                                                <XAxis
                                                    dataKey="city"
                                                    tick={{ fontSize: 10, fill: "#888" }}
                                                    interval={0}
                                                    angle={-30}
                                                    textAnchor="end"
                                                    axisLine={false}
                                                    tickLine={false}
                                                />

                                                <YAxis
                                                    allowDecimals={false}
                                                    tick={{ fontSize: 10, fill: "#888" }}
                                                    axisLine={false}
                                                    tickLine={false}
                                                // domain={[0, dataMax => dataMax + 2]}
                                                />

                                                <CartesianGrid
                                                    strokeDasharray="3 3"
                                                    vertical={false}
                                                    stroke="#f0f0f0"
                                                />


                                                <RechartTooltip
                                                    cursor={{ stroke: "#e5e7eb", strokeWidth: 1 }}
                                                    contentStyle={{
                                                        borderRadius: 8,
                                                        border: "1px solid #e0e0e0",
                                                        boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
                                                        fontSize: 12,
                                                    }}
                                                />

                                                {/* Area with gradient - render first so line appears on top */}
                                                <Area
                                                    type="monotone"
                                                    dataKey="companies"
                                                    fill="url(#cityGradient)"
                                                    stroke="none"
                                                    fillOpacity={1}
                                                    tooltipType="none"
                                                />

                                                {/* Line with larger, more visible dots */}
                                                <Line
                                                    type="monotone"
                                                    dataKey="companies"
                                                    stroke="#865adf"
                                                    strokeWidth={1}
                                                    dot={{
                                                        r: 2,
                                                        fill: "#865adf",

                                                    }}
                                                    activeDot={{
                                                        r: 6,
                                                        fill: "#865adf",
                                                        stroke: "#fff",
                                                        strokeWidth: 3,
                                                        style: { cursor: 'pointer' }
                                                    }}
                                                    animationDuration={900}
                                                />
                                            </ComposedChart>
                                        </ResponsiveContainer>
                                    ) : (
                                        <p className="text-muted fs-12">No data available</p>
                                    )}
                                </div>


                            </div>
                        </div>
                    </div>

                </div>
            )}
        </>
    )
}
